// Resolves the GCS buckets for the current deployment (by COMPANY / API_HOST).
// These are injected into the `config` prop passed to <Me>, so the shared
// ischart-deploy submodule stays host-agnostic (no build-time alias needed).
import CONFIG from "config/config";

let ISCHART_STUDIO_GS = "gs://mehealthportal-studio"
let ISCHART_INFORMATICS_GS = "gs://mehealthportal-informatics"

if (CONFIG.COMPANY === "BDMS" && CONFIG.API_HOST.includes("staging")) { 
  ISCHART_STUDIO_GS = "gs://bplus-studio"
  ISCHART_INFORMATICS_GS = "gs://bplus-staging-informatics"
} else if (CONFIG.COMPANY === "BDMS" && !CONFIG.API_HOST.includes("staging")) { 
  ISCHART_STUDIO_GS = "gs://bplus-studio"
  ISCHART_INFORMATICS_GS = "gs://bplus-informatics"
}

export {
  ISCHART_STUDIO_GS,
  ISCHART_INFORMATICS_GS  
}

